export const getStartTimeOptions = () => {
  const options = [];
  for (let val = 0; val < 24; val += 0.5) {
    const rawHour = Math.floor(val);
    const hour = rawHour === 0 || rawHour === 12 ? '12' : String(rawHour % 12);
    const minute = val % 1 === 0 ? '00' : '30';
    const amPm = val < 12 ? 'AM' : 'PM';
    options.push({
      val,
      label: `${hour}:${minute} ${amPm}`,
    });
  }
  return options;
};
